import React from 'react'
import { Route } from 'react-router-dom'
import App from '../pages/App'
import Main from '../pages/Main/Main'
import Conference from '../pages/Conference/Conference'
import ConferenceDetail from '../pages/ConferenceDetail/ConferenceDetail'
import EditConference from '../pages/EditConference/EditConference'

export default () => {
    return (
        <App>
            <Route exact path='/' component={Main} />
            <Route path='/conference/:id' component={Conference} />
            <Route path='/conferenceDetail/:id'  component={ConferenceDetail} />
            <Route path='/editConference/:id' component={EditConference} /> 
        </App>
    )
}


// WEBPACK FOOTER //
// ./src/route/app.js